import { authenticatedApiClient } from './axios'
import { USER_MY_PROFILE_ENDPOINT, USER_UPDATE_ENDPOINT } from './config/api'

export async function getMyBlockedUsers(): Promise<string[]> {
  const response = await authenticatedApiClient.get<{ blockedUsers?: string[] }>(USER_MY_PROFILE_ENDPOINT)
  return response?.blockedUsers ?? []
}

export async function updateMyBlockedUsers(userId: string, blockedUsers: string[]): Promise<void> {
  await authenticatedApiClient.patch(`${USER_UPDATE_ENDPOINT}/${userId}`, { blockedUsers })
}


